import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { isValidAccessCode, normalizeAccessCode } from './accessCode';

export function AccessCodeEntry() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const normalized = normalizeAccessCode(code);
    if (!isValidAccessCode(normalized)) {
      setError('That does not look like an access code.');
      return;
    }
    navigate(`/d/${normalized}`);
  };

  return (
    <main className="gate">
      <form className="gate-card" onSubmit={submit}>
        <span className="vitalic-mark">VITALIC</span>
        <h1>DSF-E Population Flow</h1>
        <p>Enter the access code from your invitation.</p>

        <label className="gate-field" htmlFor="access-code">
          <span className="sr-only">Access code</span>
          <input
            id="access-code"
            type="text"
            autoComplete="off"
            autoCapitalize="none"
            spellCheck={false}
            placeholder="prospect-code"
            value={code}
            onChange={(event) => {
              setCode(event.target.value);
              setError(null);
            }}
          />
        </label>

        {error && (
          <p className="gate-error" role="alert">
            {error}
          </p>
        )}

        <button type="submit">Open canvas</button>
      </form>
    </main>
  );
}
